import React from "react";
import Section from "@/Molecules/Section";
import FAQ from "@/Molecules/FAQ";
import { LandingProps } from "@/types/Landing";

const LandingFaq = ({faq}: Pick<LandingProps, 'faq'>) =>
  <Section
    lighter
    title={'Veelgestelde vragen'}
    content={<FAQ items={Object.entries(faq).map(([question, answer]) => ({[question]: answer}))} />}
  />;

export default LandingFaq;
